import * as React from 'react';
import TextField from 'material-ui/TextField';
import {TextColor} from '../../../constants/generals';

export interface ITextFieldProps {
    hintText: string;
    type: string;
    id: string;
    color?: string;
    errorText?: string;
    maxvalue?: number;
    minvalue?: number;
    onChange: (e: React.FormEvent, value) => void;
    value?: string;
    disabled?: boolean;
    required?: boolean;
}

export class TextInput extends React.PureComponent<ITextFieldProps, {}> {
    constructor(props: ITextFieldProps) {
        super(props);
    }

    public render() {
        const isInstruction = this.props.id === 'moduleInstructions';
        return <div>
            <TextField
                {...this.props}
                min={this.props.minvalue}
                max={this.props.maxvalue}
                underlineStyle={style}
                disabled={this.props.disabled}
                underlineFocusStyle={style}
                inputStyle={this.props.color ? {color: this.props.color} : inputFontStyle}
                textareaStyle={this.props.color ? {color: this.props.color} : inputFontStyle}
                floatingLabelStyle={style}
                className="mui-input"
                onChange={this.props.onChange}
                multiLine={this.props.type === 'textarea'}
                rows={isInstruction ? 10 : (this.props.type === 'textarea' ? 2 : 1)}
            />
        </div>;
    }
}

const style: React.CSSProperties = {
    color: TextColor,
    borderColor: TextColor
};

const inputFontStyle: React.CSSProperties = {
    color: TextColor
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/TextInput.tsx